import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { useEffect, useState } from 'react'
import { getAdminConfig, setAdminConfig } from 'services'
import { RenderInput } from 'utils/RenderInput'

import { defaultInputs } from './constants'

export const EmailTexts = () => {
  const [inputs, setInputs] = useState(defaultInputs())
  const [isLoading, setLoading] = useState(true)
  const [isChanged, setChanged] = useState(false)
  const [data, setData] = useState<Record<string, any>>({})

  useEffect(() => {
    getAdminConfig('emailTexts')
      .then((data) => {
        const newInputs = cloneDeep(inputs)
        Object.keys(newInputs).forEach((groupKey) =>
          Object.keys(newInputs[groupKey]).forEach((key) => (newInputs[groupKey][key].value = data[groupKey]?.[key])),
        )
        setInputs(newInputs)
        setData(data)
      })
      .finally(() => setLoading(false))
  }, [])

  const onChange = (groupKey: string, key: string, value: string) => {
    const newInputs = cloneDeep(inputs)
    newInputs[groupKey][key].value = value
    setInputs(newInputs)
    setChanged(true)
  }

  const onSave = () => {
    const _data: Record<string, any> = {}
    Object.keys(inputs).forEach((groupKey) => {
      _data[groupKey] = {}
      Object.keys(inputs[groupKey]).forEach((key) => (_data[groupKey][key] = inputs[groupKey][key].value))
    })
    _data.weeklyLoanReport.visible = data.weeklyLoanReport.visible

    setLoading(true)
    setAdminConfig('emailTexts', _data)
      .then(() => setChanged(false))
      .finally(() => setLoading(false))
  }

  const onChangeEnable = (key: string) => {
    const temp = cloneDeep(data)
    temp.weeklyLoanReport.visible[key] = !data.weeklyLoanReport.visible[key]
    setData(temp)
    setChanged(true)
  }

  const renderInputs = (groupKey: string) => {
    const group = inputs[groupKey]
    return Object.keys(group).map((key) => {
      const input = group[key]
      const visibility = data.weeklyLoanReport?.visible?.[key]
      if (!['enabled', 'time', 'weekday', 'subject'].includes(key) && input.inputType != 'section')
        input.additionalElements = (
          <span className="cursor-pointer text-shade-blue" onClick={() => onChangeEnable(key)}>
            {visibility ? <EyeIcon className="w-4 h-4" /> : <EyeSlashIcon className="w-4 h-4" />}
          </span>
        )
      return (
        <div className={`col-span-${input.span || 1} ${visibility === false ? 'opacity-30 z-10' : 'opacity-100'}`}>
          <RenderInput Key={key} input={input} onChange={(key: string, value: any) => onChange(groupKey, key, value)} />
        </div>
      )
    })
  }

  return (
    <div>
      <LayoutLoading show={isLoading} />
      <div className="grid grid-cols-3 gap-4">{Object.keys(inputs).map(renderInputs)}</div>

      <SaveChanges show={isChanged} label="Save Changes" onSave={onSave} />
    </div>
  )
}
